import React, { useState, useEffect } from "react";
import classes from './Customers.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import api from "../../Components/API/Api";
import Swal from 'sweetalert2';
import AddCustomerModal from "../../Components/Modals/AddCustomerModal";
import BulkUploadCustomersModal from "../../Components/Modals/BulkUploadCustomersModal";

const Customers = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);

  const totalTransactions = customers.reduce((acc, customer) => {
    return acc + (customer.ledgers?.length || 0);
  }, 0);

  const totalBalance = customers.reduce((acc, customer) => {
    return acc + Number(customer.balance || 0);
  }, 0);


  useEffect(() => {
    const authToken = localStorage.getItem('authToken');

    if (!authToken) {
      setError("Authorization token not found.");
      navigate('/signin');
      return;
    }

    const fetchCustomers = async () => {
      try {
        const res = await api.get(`/v1/customer`);

        const customerData = res.data?.data?.data || res.data?.data || [];
        setCustomers(customerData);
      } catch (err) {
        console.error("Error fetching customers:", err?.response?.data || err.message);
        setError(err.response?.data?.message || "Failed to fetch customers. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, [navigate]);


  const pageMap = {
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/accounts': 'Accounting',
    '/reports': 'Reports',
    '/banking': 'Banking',
    '/settings': 'Settings',
    '/transactions/sales-invoice/sale': 'Transactions',
    '/inventory/PurchaseOrder': 'Transactions',
    '/settings/product-services': 'Settings'
  };

  const renderSkeletonRows = () =>
    [...Array(6)].map((_, i) => (
      <tr key={i} className={classes.tableRow}>
        {Array.from({ length: 7 }).map((__, j) => (
          <td key={j} className={classes.tableCell}>
            <div className={classes.skeletonBox}></div>
          </td>
        ))}
      </tr>
    ));

  const handleBulkUploadSuccess = (uploaded) => {
    if (!uploaded) return;

    let items = [];

    if (Array.isArray(uploaded)) items = uploaded;
    else if (Array.isArray(uploaded.data)) items = uploaded.data;
    else if (Array.isArray(uploaded.customers)) items = uploaded.customers;
    else if (Array.isArray(uploaded.data?.data)) items = uploaded.data.data;
    else if (typeof uploaded === 'object') items = [uploaded];

    if (items.length === 0) return;

    setCustomers(prev => {
      const existingIds = new Set(prev.map(c => c.id));
      const newItems = items.filter(it => it && (it.id == null || !existingIds.has(it.id)));
      if (newItems.length === 0) return prev;
      return [...newItems, ...prev];
    });
  };

  const handleEditClick = (customer) => {
    setEditingCustomer(customer);
    setIsModalOpen(true);
  };

  const handleModalSuccess = (updatedData) => {
    if (editingCustomer) {
      // Edit mode: update the existing customer in the list
      setCustomers(prev =>
        prev.map(c => c.id === updatedData.id ? updatedData : c)
      );
      setEditingCustomer(null);
    } else {
      // Add mode: add new customer to the list
      setCustomers(prev => [...prev, updatedData]);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditingCustomer(null);
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.Container}>
        <div className={classes.actions}>
          <button className={classes.btns}
            onClick={() => navigate('/transactions/sales-invoice/sale')}>Sales Invoice</button>
          <button className={classes.btns}
            onClick={() => navigate('/inventory/PurchaseOrder')}>Purchase Invoice</button>
          <button className={classes.btnsq}>Customers</button>
          <button className={`${classes.btns} ${classes.greens}`}
            onClick={() => navigate('/settings/product-services')}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Customers</h2>
          <h1 className={classes.Titles}>
            Manage your customer's transactions, customer's invoices, and payments.
          </h1>
        </header>

        {/* <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Customers</p>
                <p className={classes.kdptg1}>{customers.length}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Available Customers</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This Month Balance</p>
                <p className={classes.kdptg2}>₦{totalBalance.toLocaleString()}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total Spent</p>
                </div>
              </div>
            </div>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Replenishments</p>
                <p className={classes.kdptg3}>₦3,200,000.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This Month</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Transactions</p>
                <p className={classes.kdptg4}>{totalTransactions}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This Month</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search all entries" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Methods</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>
            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <div className={classes.thrdkad}>
            <div className={classes.kad}>
              <p className={classes.kdptg}>Total Customers</p>
              <p className={classes.kdptg1}>{customers.length}</p>

            </div>
          </div>
          <div className={classes.btnsMain} >
            {/* <button className={classes.btnssWhite}> Replenish</button> */}
            <div style={{width: "50%"}}>
              <button className={classes.btnUpload} onClick={() => setIsBulkModalOpen(true)}> Upload Customers</button>
            </div>
           <div style={{width: "50%"}}>
            <button className={classes.btnss} onClick={() => setIsModalOpen(true)}> + New Customer</button>
          </div>
          </div>
        </div>

        <div className={classes.tableContainer}>
          {error ? (
            <p style={{ color: "red", padding: "10px" }}>{error}</p>
          ) : (
            <table className={classes.table}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th>#</th>
                  <th>Customer Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Balance</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading
                  ? renderSkeletonRows()
                  : customers.map((customer, index) => (
                    <tr key={customer.id || index} className={classes.tableRow}>
                      <td className={classes.tableCell}>{index + 1}</td>
                      <td className={classes.tableCell}>{customer.name}</td>
                      <td className={classes.tableCell}>{customer.email || '—'}</td>
                      <td className={classes.tableCell}>{customer.phone || '—'}</td>
                      <td className={classes.tableCell3}>
                        {Number(customer.balance || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                      </td>
                      <td className={classes.tableCell}>
                        {(() => {
                          const hasLedger = customer.ledger != null && customer.ledger !== '';
                          const hasLedgersArray = Array.isArray(customer.ledgers) && customer.ledgers.length > 0;
                          const active = hasLedger || hasLedgersArray;
                          return (
                            <span style={{
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              color: active ? 'white' : '#555',
                              background: active ? 'rgba(22, 163, 74, 1)' : '#E5E7EB'
                            }}>
                              {active ? 'Active' : 'Inactive'}
                            </span>
                          );
                        })()}
                      </td>
                      <td className={classes.tableCell}>{customer.created_at?.split("T")[0] || '—'}</td>
                      <td className={classes.tableCell}>
                        <div className={classes.actionIcons}>
                          <Eye size={16} style={{ color: 'rgba(22, 163, 74, 1)' }} />
                          <Edit 
                            size={16} 
                            style={{ margin: '0 8px', color: 'rgba(37, 99, 235, 1)', cursor: 'pointer' }}
                            onClick={() => handleEditClick(customer)}
                          />
                          <Trash size={16} style={{ color: 'rgb(255, 2, 2)' }} />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>

        <table className={classes.footerTable}>
          <tfoot>
            <tr>
              <td>First</td>
              <td className={`${classes.page} ${classes.activePage}`}>1</td>
              <td className={classes.page}>2</td>
              <td>Last</td>
            </tr>
            <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>
          </tfoot>
        </table>
      </div>

      <Footer />

      <AddCustomerModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onSuccess={handleModalSuccess}
        editingCustomer={editingCustomer}
      />

      <BulkUploadCustomersModal
        isOpen={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        onSuccess={handleBulkUploadSuccess}
      />

    </div>
  );
};

export default Customers;
